import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

class ComprobanteStatus extends Component {

  get config() {
    const { status } = this.props;

    let variant = 'success';
    let icon = 'circle';
    let text = 'Vigente';

    switch (status) {
      case 'cancelling':
          variant = 'warning';
          icon = 'clock';
          text = 'Cancelando';
        break;

      case 'cancelled':
          variant = 'danger';
          icon = 'circle';
          text = 'Cancelado';
        break;

      case 'undefined':
      case undefined:
          variant = 'info';
          icon = 'circle';
          text = '...';
        break;

      default:
        break;
    }

    return {
      icon,
      variant,
      text
    }
  }

  render() {
    const { variant, text } = this.config;

    return (
      <Badge pill variant={ variant }>
        { text }
      </Badge>
    )
  }
}

export default ComprobanteStatus;